

// // https://www.figma.com/file/1JPM637EZkNezdFQI4xL6w/Event-Management-App?type=design&node-id=146-1170&mode=design
import {
  Box,
  Button,
  Chip,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { InfoContext } from "../services/Context/Info/context";
import Lead from "../services/db/leads";
import User from "../services/db/user";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import formatToMMDDYY from "../utils/formatDate"

import htmlToPdf from "../utils/htmlToPdf";
import objToXlsx from "../utils/objToXlsx";

const ServiceProviderView = () => {
  const pdfRef = useRef(null);
  const {
    data: { serviceProviderPage, clientsReqCount, userData },
    setData,
  } = useContext(InfoContext);

  const p = useParams();
  const USER_ID = p.id.split("_").pop();
  const navigate = useNavigate();

  const fields = [
    { disabled : false,  label: "Contact", code: "phoneNumber" },
    { disabled : false , label: "Enter Your Name", code: "displayName" },
    { disabled : false , label: "Email Id", code: "email" },
    { disabled : false , label: "Date of Birth", code: "dateOfBirth" },
    { disabled : false , label: "Gender", code: "gender" },
    { disabled : false , label: "Address", code: "address" },
    { disabled : true , label: "Duration", code: "duration" },
    { disabled : true , label: "Amount", code: "amount" },
    
  ];

  const tProps = {
    variant: "standard",
    size: "small",
    sx: { width: "75%" },
  };

  const [formData, setFormData] = useState({});

  useEffect(() => {
    const fetchServiceProviderData = async () => {
      try {
        if (!serviceProviderPage || serviceProviderPage?.id !== p.id) {
          const r = await new User().findUser(USER_ID);
          const res = await new Lead().providerRequestsCount(r?.phoneNumber);
          setData((prev) => ({
            ...prev,
            serviceProviderPage: r,
            clientsReqCount: res,
          }));
        }
      } catch (err) {
        console.error("Error fetching service provider data:", err);
      }
    };
    fetchServiceProviderData();
  }, [p.id]);

  useEffect(() => {
    if (serviceProviderPage) {
      const initial = {};
      fields.forEach((el) => {
        initial[el.code] = serviceProviderPage[el.code] || "";
      });

      initial.subscriptionStartDate = serviceProviderPage.subscriptionStartDate
        ? dayjs(serviceProviderPage.subscriptionStartDate)
        : null;

      initial.subscriptionEndDate = serviceProviderPage.subscriptionEndDate
        ? dayjs(serviceProviderPage.subscriptionEndDate)
        : null;

      setFormData(initial);
    }
  }, [serviceProviderPage]);

  const handleChange = (code) => (event) => {
    setFormData((prev) => ({ ...prev, [code]: event.target.value }));
  };

  const handleDateChange = (code) => (newValue) => {
    setFormData((prev) => ({
      ...prev,
      [code]: newValue,
    }));
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formData,
        subscriptionStartDate: formData.subscriptionStartDate
          ? formData.subscriptionStartDate.toISOString()
          : null,
        subscriptionEndDate: formData.subscriptionEndDate
          ? formData.subscriptionEndDate.toISOString()
          : null,
      };

      await new User().updateUser(USER_ID, payload);
      alert("User information updated successfully!");
      navigate("/service-provider");
    } catch (error) {
      console.error("Failed to update user:", error);
      alert("Failed to update user");
    }
  };

  const hBlock = (active) => {
    new User()
      .updateUser(
        `${serviceProviderPage.phoneNumber}_${serviceProviderPage.role}`,
        { active }
      )
      .then(() => {
        if (userData?.length) {
          const ind = userData.findIndex(
            (el) =>
              el.phoneNumber === serviceProviderPage.phoneNumber &&
              el.role === serviceProviderPage.role
          );
          userData[ind] = { ...userData[ind], active };
          setData((p) => ({ ...p, userData }));
        }
        alert(`User ${active ? "blocked" : "unblocked"} successfully`);
      });
  };

  return (
    <Box>
      <Grid container direction="column">
        <Grid xs={12} paddingY={1} paddingLeft={5}>
          <Typography>Service Provider</Typography>
        </Grid>

        <Grid container direction="row" paddingY={1} paddingLeft={5}>
          <Grid xs={2}>
            <Button
              variant="contained"
              sx={{ width: "95%", bgcolor: "#ff258d", color: "#212121" }}
              onClick={() =>
                objToXlsx(
                  {
                    ...(serviceProviderPage || {}),
                    count: clientsReqCount || 0,
                  },
                  "serviceProvider"
                )
              }
            >
              Excel
            </Button>
          </Grid>
          <Grid xs={2}>
            <Button
              variant="contained"
              sx={{ width: "95%", bgcolor: "#ff258d", color: "#212121" }}
              onClick={() => htmlToPdf(pdfRef.current, p.id, "save")}
            >
              PDF
            </Button>
          </Grid>
        </Grid>

        <Grid container direction="row" paddingY={2} ref={pdfRef}>
          <Grid xs={9} container direction="column">
            <Grid container direction="row">
              <Grid xs={4} paddingLeft={5} container alignItems="center">
                <Typography>{serviceProviderPage?.displayName}</Typography>
              </Grid>
              <Grid
                xs={8}
                container
                direction="column"
                paddingRight={10}
                alignItems="flex-end"
              >
                <Button
                className="hidden"
                  sx={{ color: "#b3b3b3" }}
                  size="small"
                  onClick={() => hBlock(Boolean(serviceProviderPage?.active))}
                >
                  {/* {serviceProviderPage?.active ? "Ban" : "Unban"} Profile */}
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid xs={9} container direction="column" paddingY={2} bgcolor="#faf0e6">
            <Grid container justifyContent="space-between" paddingLeft={5}>
              <Grid xs={3}>
                <Typography>Total customer contact</Typography>
                <Typography>{clientsReqCount || 0}</Typography>
              </Grid>
              <Grid xs={3}>
                <Typography>Total Services</Typography>
                <Typography>
                  {serviceProviderPage?.subcategories?.length || 0}
                </Typography>
              </Grid>
              <Grid xs={3}>
                <Typography>Customer Rating</Typography>
                <Typography>4.5</Typography>
              </Grid>
              <Grid xs={3}>
                <Typography>Membership Till</Typography>
                <Typography> 
                {serviceProviderPage?.subscriptionEndDate &&  formatToMMDDYY(serviceProviderPage?.subscriptionEndDate)}
                </Typography>
              </Grid>
            </Grid>

            <Grid container paddingTop={2} paddingLeft={5}>
              <Grid xs={12}>
                <Typography>Service Categories</Typography>
              </Grid>
              <Box display="flex" flexWrap="wrap" gap={1}>
                <Chip
                  label={serviceProviderPage?.category}
                  variant="filled"
                  size="small"
                  color="primary"
                />
                {serviceProviderPage?.subCategories?.map((item) => (
                  <Chip
                    key={item}
                    label={item}
                    variant="filled"
                    size="small"
                    color="primary"
                  />
                ))}
              </Box>
            </Grid>
          </Grid>

          <Grid xs={9} container direction="row" paddingTop={2}>
            <Grid xs={4} paddingLeft={5}>
              <Typography>{`Owner's Details`}</Typography>
              {serviceProviderPage?.photoURL && (
                <img
                  src={serviceProviderPage.photoURL}
                  width="100"
                  height="100"
                  alt="owner"
                />
              )}
            </Grid>

            <Grid xs={4} container direction="column" gap={2}>
              {fields.map((el) => (
                <TextField
                disabled={el.disabled}
                  key={el.code}
                  {...tProps}
                  label={el.label}
                  value={formData[el.code] || ""}
                  onChange={handleChange(el.code)}
                />
              ))}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                disabled
                  label="Subscription Start Date"
                  value={formData.subscriptionStartDate}
                  onChange={handleDateChange("subscriptionStartDate")}
                  renderInput={(params) => <TextField {...params} {...tProps} />}
                />
                <DatePicker
                  label="Subscription End Date"
                  value={formData.subscriptionEndDate}
                  onChange={handleDateChange("subscriptionEndDate")}
                  renderInput={(params) => <TextField {...params} {...tProps} />}
                />
              </LocalizationProvider>

              <Button
                variant="contained"
                sx={{ mt: 2, bgcolor: "#ff258d", color: "#212121" }}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Grid>

            <Grid
              xs={4}
              container
              direction="column"
              justifyContent="center"
              alignItems="flex-start"
              paddingLeft={2}
            >
              <Typography>Bio</Typography>
              <Typography>{serviceProviderPage?.bio}</Typography>
              <Typography>Portfolio</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ServiceProviderView;
